import React, { useEffect } from "react";
import "./Footer.css"; // Ensure you have proper CSS styles
import logo from "../../dextra-logo.jpeg";
import app from "../Assets/app.svg";
import play from "../Assets/play.svg";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  FaFacebookF,
  FaTwitter,
  FaTiktok,
  FaPinterestP,
  FaInstagram,
} from "react-icons/fa";
import { IoLogoYoutube } from "react-icons/io";
import { FaXTwitter } from "react-icons/fa6";


const Footer = () => {
  useEffect(() => {
    window.scroll(0, 0);
  }, []);


  const navigate = useNavigate();
  const accessToken = useSelector((state) => state.auth?.auth?.access_token);
  return (
    <div className="container-fluid">
      <div className="row footer  ">
        <div className="footer-container">
          {/* Left Section - Company Info */}

          <div className="col-lg-2 col-md-4 col-12">
            <div className="footer-company">

              <img src={logo} alt="company_logo" className="company-name"
                onClick={() => { navigate('/') }}
              ></img>
              {/* <p className="company-description">
                Morbi cursus porttitor enim in lobortis molestie. Duis gravida
                turpis dui, eget bibendum magna congue nec.
              </p> */}
              <p className="contact-info">
                <a href="tel:+91 4448648848" className="" style={{ color: "black", textDecoration: "none" }}>+91 4448648848</a>
                <span className="or-center"> or </span>
                {/* <a href="mailto:enquiry@shambasync.com" className="email">enquiry@shambasync.com</a> */}
                <a
                  href="https://mail.google.com/mail/?view=cm&to=info@dextratechnologies.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="email"
                  style={{ color: "black", textDecoration: "none" }}
                >
                  info@dextratechnologies.com
                </a>

              </p>

            </div>
          </div>

          {/* Middle Section - Links */}
          <div className="col-lg-3  col-md-4 col-12">
            <div className="footer-links">
              {/* {accessToken && (
                <div className="footer-column">
                  <h3>My Account</h3>
                  <ul>
                    <li onClick={() => navigate("/user")}>My Account</li>
                    <li onClick={() => navigate("/order_view")}>Order History</li>
                    <li onClick={() => navigate("/Shopping_Cart")}>Shopping Cart</li>
                    <li onClick={() => navigate("/whish")}>Wishlist</li>
                  </ul>
                </div>
              )} */}
              <div className="footer-column">
                <h3>Quick Links</h3>
                <ul>
                  <li onClick={() => navigate("/about")}>About Us </li>
                  <li onClick={() => navigate("/blog")}>Blog </li>
                  <li onClick={() => navigate("/shop")}>Shop </li>
                  <li onClick={() => navigate("/faq")}>FAQs  </li>

                  {accessToken && (<li onClick={() => navigate('/order_view')}>Track Order</li>

                  )}
                </ul>
              </div>
              <div className="footer-column">
                <h3>Helps</h3>
                <ul>
                  <li onClick={() => navigate("/contact")}>Contact</li>
                  {/* <li onClick={() => navigate("/faq")}>FAQs</li> */}
                  <li onClick={() => navigate('/terms')} style={{ cursor: 'pointer' }}>Terms & Condition</li>
                  <li onClick={() => navigate('/privacy')} style={{ cursor: 'pointer' }}>Privacy Policy</li>
                </ul>
              </div>


            </div>
          </div>

          <div className="col-lg-2 col-md-4 col-12 ">
            <div className="download-title">Contact</div>
            <p style={{ fontSize: "14px", color: "#555", lineHeight: "1.9" }}>
              1st Floor, Aqua Mall, Door #1A, Plot #1, Cart Track Rd, Velachery, Chennai, Tamil Nadu 600032
            </p>
          </div>


          <div className="col-lg-3 col-md-4 col-12">
            <div className="download-title">Download Mobile App</div>
            <div className="download">
              <div className="appstore">
                <a
                  href="https://apps.apple.com" // Replace with your App Store link
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={app} alt="App Store" />
                </a>
              </div>
              <div className="playstore">
                <a
                  href="https://play.google.com" // Replace with your Google Play link
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={play} alt="Google Play" />
                </a>
              </div>
            </div>
            <br />
            {/* <div className="footer-social">
              <a
                href="https://www.instagram.com/shamba_sync/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaInstagram />
              </a>
              <a
                href="https://web.facebook.com/profile.php?id=61576904680253"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaFacebookF />
              </a>
              <a
                href="https://www.youtube.com/@Shambasynckenya"
                target="_blank"
                rel="noopener noreferrer"
              >
                <IoLogoYoutube />
              </a>
              <a
                href="https://x.com/shambasync"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaXTwitter />
              </a>
              <a
                href="https://www.tiktok.com/@shambasync"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaTiktok />
              </a>
            </div> */}
          </div>
        </div>

        {/* Bottom Section - Copyright & Payment Methods */}
      </div>
    </div>
  );
};

export default Footer;
